import React, { useEffect } from "react";
import { useQuery } from '@tanstack/react-query';

import * as QUERIES from "../query-functions";

export default function SelectBestAvailablePrice(props) {

    const {
        isLoading,
        isFetching,
        isError,
        refetch,
        data: bestAvailableByPriceData,
    } = useQuery({
        queryKey: ["bestAvailableByPriceData", props.band.band_ids],
        queryFn: () =>  QUERIES.getBestAvailableByBands(props.ticketQuantity, props.band.band_ids),
        enabled: false,
        retry: false
    });

    useEffect(() => {
        if (!props.priceListOpen) return;

        // Debounce refetching incase the user changes the ticket quantity in rapid succession
        const handler = setTimeout(() => {
            refetch();
        }, 300);
    
        return () => clearTimeout(handler);
    }, [props.ticketQuantity, props.priceListOpen]);

    useEffect(() => {
        // Use this in the parent component to set a loading state if any of the prices are loading
        props.setPricesPending({...props.pricesPending, [props.band.amount]: isLoading || isFetching});
    }, [isLoading, isFetching]);
    
    if (!bestAvailableByPriceData && (bestAvailableByPriceData?.length < props.ticketQuantity) || isError || !props.band?.amount) return null;

    return (
        <div className="form-field--radio">
            <input type='radio' 
                    name="select-quantity--price"
                    value={props.band.amount} 
                    id={`price-${props.band.amount}`}
                    disabled={props.loadingAllPrices}
                    onClick={() => props.setSelectedPrice(props.band)} />
            <label htmlFor={`price-${props.band.amount}`}>£{parseFloat(props.band.amount)?.toFixed(2)}</label>
        </div>
    )
}
